<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();
</script>

<template>
  <div
    data-slot="dialog-header"
    :class="
      cn('flex flex-col space-y-1.5 text-center sm:text-left', props.class)
    "
  >
    <slot />
  </div>
</template>
